export default __webpack_public_path__ + "static/media/larson.45192f28.jpg";